import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { OrphanAccountRedirect } from '#client/components/OrphanAccountRedirect';
import { ENABLE_ORPHAN_ACCOUNTS_REDIRECT } from '#client/constants/experimentsFlags';
import { useOrderTrackerStatus } from '#client/hooks/useOrderTrackerStatus';

import Home from './Home';

const Renderer = () => {
  const { orderTasksWithStatus, loading } = useOrderTrackerStatus();
  const enableOrphanAccountsRedirect = useExperimentFlag(ENABLE_ORPHAN_ACCOUNTS_REDIRECT, false);

  // Redirect only if user has no order tasks
  const shouldRedirectOrphanAccount = !loading && orderTasksWithStatus?.length === 0;

  return (
    <>
      {shouldRedirectOrphanAccount && enableOrphanAccountsRedirect && <OrphanAccountRedirect />}
      <Home loading={loading} />
    </>
  );
};

export default Renderer;
